import { render, staticRenderFns } from "./DomainManagement.vue?vue&type=template&id=d1a1f8ca&scoped=true&"
import script from "./DomainManagement.vue?vue&type=script&lang=js&"
export * from "./DomainManagement.vue?vue&type=script&lang=js&"
import style0 from "./DomainManagement.vue?vue&type=style&index=0&id=d1a1f8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a1f8ca",
  null
  
)

export default component.exports